import { useContext } from 'react';

import { PreloaderContext } from '../components';

/**
 * Возвращает контекст отслеживания функций подгрузки данных.
 */
export const usePreloader = () => useContext(PreloaderContext);
